"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sagas;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _clearSuggestedActionsOnPostActivitySaga = _interopRequireDefault(require("./sagas/clearSuggestedActionsOnPostActivitySaga"));

var _connectionStatusToNotificationSaga = _interopRequireDefault(require("./sagas/connectionStatusToNotificationSaga"));

var _connectionStatusUpdateSaga = _interopRequireDefault(require("./sagas/connectionStatusUpdateSaga"));

var _connectSaga = _interopRequireDefault(require("./sagas/connectSaga"));

var _detectSlowConnectionSaga = _interopRequireDefault(require("./sagas/detectSlowConnectionSaga"));

var _emitTypingIndicatorToPostActivitySaga = _interopRequireDefault(require("./sagas/emitTypingIndicatorToPostActivitySaga"));

var _incomingActivitySaga = _interopRequireDefault(require("./sagas/incomingActivitySaga"));

var _markAllAsSpokenOnStopSpeakActivitySaga = _interopRequireDefault(require("./sagas/markAllAsSpokenOnStopSpeakActivitySaga"));

var _postActivitySaga = _interopRequireDefault(require("./sagas/postActivitySaga"));

var _sendEventToPostActivitySaga = _interopRequireDefault(require("./sagas/sendEventToPostActivitySaga"));

var _sendFilesToPostActivitySaga = _interopRequireDefault(require("./sagas/sendFilesToPostActivitySaga"));

var _sendMessageBackToPostActivitySaga = _interopRequireDefault(require("./sagas/sendMessageBackToPostActivitySaga"));

var _sendMessageToPostActivitySaga = _interopRequireDefault(require("./sagas/sendMessageToPostActivitySaga"));

var _sendPostBackToPostActivitySaga = _interopRequireDefault(require("./sagas/sendPostBackToPostActivitySaga"));

var _sendTypingIndicatorOnSetSendBoxSaga = _interopRequireDefault(require("./sagas/sendTypingIndicatorOnSetSendBoxSaga"));

var _speakActivityAndStartDictateOnIncomingActivityFromOthersSaga = _interopRequireDefault(require("./sagas/speakActivityAndStartDictateOnIncomingActivityFromOthersSaga"));

var _startDictateOnSpeakCompleteSaga = _interopRequireDefault(require("./sagas/startDictateOnSpeakCompleteSaga"));

var _startSpeakActivityOnPostActivitySaga = _interopRequireDefault(require("./sagas/startSpeakActivityOnPostActivitySaga"));

var _stopDictateOnCardActionSaga = _interopRequireDefault(require("./sagas/stopDictateOnCardActionSaga"));

var _stopSpeakingActivityOnInputSaga = _interopRequireDefault(require("./sagas/stopSpeakingActivityOnInputSaga"));

var _submitSendBoxSaga = _interopRequireDefault(require("./sagas/submitSendBoxSaga"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(sagas);

function sagas() {
  return _regenerator["default"].wrap(function sagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.fork)(_clearSuggestedActionsOnPostActivitySaga["default"]);

        case 2:
          _context.next = 4;
          return (0, _effects.fork)(_connectionStatusToNotificationSaga["default"]);

        case 4:
          _context.next = 6;
          return (0, _effects.fork)(_connectionStatusUpdateSaga["default"]);

        case 6:
          _context.next = 8;
          return (0, _effects.fork)(_connectSaga["default"]);

        case 8:
          _context.next = 10;
          return (0, _effects.fork)(_detectSlowConnectionSaga["default"]);

        case 10:
          _context.next = 12;
          return (0, _effects.fork)(_emitTypingIndicatorToPostActivitySaga["default"]);

        case 12:
          _context.next = 14;
          return (0, _effects.fork)(_incomingActivitySaga["default"]);

        case 14:
          _context.next = 16;
          return (0, _effects.fork)(_markAllAsSpokenOnStopSpeakActivitySaga["default"]);

        case 16:
          _context.next = 18;
          return (0, _effects.fork)(_postActivitySaga["default"]);

        case 18:
          _context.next = 20;
          return (0, _effects.fork)(_sendEventToPostActivitySaga["default"]);

        case 20:
          _context.next = 22;
          return (0, _effects.fork)(_sendFilesToPostActivitySaga["default"]);

        case 22:
          _context.next = 24;
          return (0, _effects.fork)(_sendMessageBackToPostActivitySaga["default"]);

        case 24:
          _context.next = 26;
          return (0, _effects.fork)(_sendMessageToPostActivitySaga["default"]);

        case 26:
          _context.next = 28;
          return (0, _effects.fork)(_sendPostBackToPostActivitySaga["default"]);

        case 28:
          _context.next = 30;
          return (0, _effects.fork)(_sendTypingIndicatorOnSetSendBoxSaga["default"]);

        case 30:
          _context.next = 32;
          return (0, _effects.fork)(_speakActivityAndStartDictateOnIncomingActivityFromOthersSaga["default"]);

        case 32:
          _context.next = 34;
          return (0, _effects.fork)(_startDictateOnSpeakCompleteSaga["default"]);

        case 34:
          _context.next = 36;
          return (0, _effects.fork)(_startSpeakActivityOnPostActivitySaga["default"]);

        case 36:
          _context.next = 38;
          return (0, _effects.fork)(_stopDictateOnCardActionSaga["default"]);

        case 38:
          _context.next = 40;
          return (0, _effects.fork)(_stopSpeakingActivityOnInputSaga["default"]);

        case 40:
          _context.next = 42;
          return (0, _effects.fork)(_submitSendBoxSaga["default"]);

        case 42:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}